import * as types from '../actions/actionTypes';

export const UI_POPUP_TYPES = {
  imeValues: "imeValues",
  aiPopup: "aiPopup",
}

const getDefaultUiPopupState = () => {
  return {
    headerTextId: "",
    style: null,
    className: "",
    opened: false,
    type: 0,
    context: {}, // here we store all popup values
    buttons: [],
  }
}

const initialState = {
  visible: false,
  message: '',
  error: '',
  title: "",
  inline: false,
  newStyles: false,
  buttons: [],
  click: null,
  // type: null, // added for look // not used
  uiPopupState: getDefaultUiPopupState(),
};

export default function(state = initialState, action) {

  switch(action.type) {

    case types.CHANGE_MESSAGE_BOX:
      return Object.assign({}, state, {
        ...action.payload
      });
    case types.SET_UI_POPUP_STATE:
      state = action.payload.uiPopupState.opened
        ? { ...state, ...action.payload}
        : {...state, uiPopupState: getDefaultUiPopupState()};
      break;

  }

  return state;

}
